<template>
    <div style="padding: 0 5%;" color="success" class="mt-5">
        <transition name="fade" appear>
            <v-alert v-if="cargaExitosa" elevation="24" color="#D6FAE5" max-width="450px" dismissible
                style="position: fixed; color: #00854D!important; z-index: 9999; left: 50%; top: 50px; transform: translate(-50%, -50%);"
                id="alert-firma-simple-biblioteca">
                La información se guardo con éxito.
            </v-alert>
        </transition>
        <transition name="fade" appear>
            <v-alert v-if="cargaErronea" elevation="24" color="#F8ADB4" max-width="450px" dismissible
                style="position: fixed; color: #1E1E1E!important; z-index: 9999; left: 50%; top: 50px; transform: translate(-50%, -50%);"
                id="alert-firma-simple">
                Error al guardar la información, inténtalo de nuevo
            </v-alert>
        </transition>
        <h5 class="text-dark text-left">Biblioteca Digital</h5>
        <hr style="background-color: #000;">
        <v-spacer></v-spacer>
        <div class="my-5" style="padding: 25px 0%;">
            <v-form ref="form" v-model="valid" lazy-validation>

                <v-text-field label="Título" outlined single-line counter="100" v-model="title"
                    :rules="titleRules"></v-text-field>
                <v-text-field label="Enlace" outlined single-line v-model="link" :rules="linkRules"
                    v-if="categoryName == 'Articulos'"></v-text-field>
                <v-textarea name="input-7-1" label="Texto o descripción" single-line counter="500" value="" outlined
                    v-model="description" :rules="descriptionRules" v-if="categoryName !== 'Videos'"></v-textarea>

                <v-card class="mx-auto" max-width="100%" outlined>
                    <div v-if="!isEditionResource">
                        <iframe :src="linkManual" width="100%" height="400px" v-if="linkManual" />
                        <v-img class="white--text align-end" height="300px" :src="src_img" v-if="src_img" lazy-src />
                        <video controls width="100%" height="400px" v-if="categoryName == 'Videos'" ref="videoElement">
                            <source :src="src_video" type="video/mp4" />
                        </video>
                    </div>
                    <div v-else>
                        <iframe :src="linkManual" width="100%" height="400px" v-if="currentDocument.linkManual" />
                        <v-img class="white--text align-end" height="300px" :src="src_img" v-if="src_img" lazy-src />
                        <video controls width="100%" height="400px" v-if="categoryName == 'Videos'" ref="videoElement">
                            <source :src="src_video" type="video/mp4" />
                        </video>
                    </div>

                    <v-card-subtitle class="pb-0 text-start">
                        {{ categoryName == 'Manuales' ? 'Documento' : categoryName == 'Videos' ? 'Video' : 'Imagen artículo'
                        }}
                    </v-card-subtitle>
                    <v-card-text class="text--primary text-start">
                        <div> <strong>Formato:</strong> {{ categoryName == 'Articulos' ? 'JPG. o PNG.' : categoryName ==
                            'Videos' ? 'MP4' : 'PDF' }}</div>
                        <div> <strong>Peso máximo:</strong> {{ categoryName == 'Articulos' ? '2 MB' : categoryName ==
                            'Videos' ? '100 MB' : '20 MB ' }} </div>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-content-end">
                        <v-btn color="primary" text @click="dialog = true">
                            {{ isEditionResource ? 'Remplazar' : 'Subir' }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
            <div class="mt-5 d-flex justify-content-center gap-5">
                <v-btn color="primary" outlined :to="{ name: 'AdministracionBibliotecaDigital' }">
                    Cancelar
                </v-btn>
                <v-btn color="primary" @click="validate()" :loading="isLoading" :disabled="!valid">
                    Guardar
                </v-btn>
            </div>
        </div>
        <!-- Alert para subir recurso -->
        <v-dialog v-model="dialog" width="500">
            <v-card class="drop-area" @dragover.prevent="dragOver" @dragleave.prevent="dragLeave" @drop.prevent="dropFile">
                <v-card-title class="d-flex flex-column align-items-start">
                    <h2 class="text-h5 lighten-2">{{ categoryName == 'Articulos' ? 'Imagen' : categoryName == 'Manuales' ?
                        'Documentos' : 'Video' }}</h2>
                    <h6 class="text-subtitle-1">Peso máximo: {{ categoryName == 'Articulos' ? '2 MB' : categoryName ==
                        'Manuales' ? '20 MB ' : '100 MB' }} </h6>
                </v-card-title>
                <v-card-text>
                    <v-file-input v-model="selectedFile" single-line
                        :label="categoryName == 'Articulos' ? 'Imagen' : categoryName == 'Manuales' ? 'Documentos' : 'Video'"
                        color="#000" outlined :accept="acceptedFileTypes" :max-size="maxFileSize" @change="validateFile"
                        ref="fileInput" class="custom-file-input" :error="inputErrorValidate" :error-messages="textError"
                        hint="Arrastra o suelta el archivo para subirlo." persistent-hint
                        :placeholder="categoryName == 'Articulos' ? 'Imagen' : categoryName == 'Manuales' ? 'Documentos' : 'Video'">
                    </v-file-input>
                    <p class="text-caption text-start">
                        {{ '' }}
                    </p>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialog = false, textError = '', inputErrorValidate = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" @click="setPreviewResource()" :disabled="!selectedFile">
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
const ruteBibliotecaDigital = "/api/BibliotecaDigital/BibliotecaDigital/";
export default {
    name: 'InsUpdateResourceDigitalLibrary',
    data() {
        return {
            id: 0,
            title: '',
            description: '',
            src_img: '',
            src_video: '',
            type: '',
            size: '',
            dateCreated: '',
            link: '',
            dialog: false,
            selectedFile: null,
            isModeEdition: false,
            url: '', // Inicializar url con una cadena vacía
            linkManual: '',
            cargaExitosa: false,
            cargaErronea: false,
            previewImageUrl: null,
            textError: '',
            inputErrorValidate: false,
            isLoading: false,
            rules: {
                required: value => !!value || 'Campo requerido',
            },
            nuevolink: null,
            valid: true,
            titleRules: [
                v => !!v || 'Campo requerido',
                v => (v && v.length <= 100) || 'Debe contener menos de 100 caracteres'
            ],
            linkRules: [
                v => !!v || 'Campo requerido'
            ],
            descriptionRules: [
                v => !!v || 'Campo requerido',
                v => (v && v.length <= 500) || 'Debe contener menos de 500 caracteres'
            ],
            existFile : false 
        }
    },
    methods: {
        validate() {
            if (this.$refs.form.validate()) {
                this.insUpdateFile()
            }
            else {
                this.cargaErronea = true;
            }
        },
        validateFile(file) {
            this.textError = ''
            if (file == null) return
            const fileType = file.type
            const fileSize = file.size

            if (this.categoryName == 'Videos') {
                if (fileType == 'video/mp4') {
                    this.selectedFile = file
                    this.inputErrorValidate = false
                    this.textError = ''
                }
                else {
                    this.inputErrorValidate = true
                    this.$refs.fileInput.reset()
                    if (fileType != 'video/mp4') {
                        this.textError = 'El archivo no cumple con el formato, carga el archivo nuevamente.'
                    }
                    if (fileSize > this.maxFileSize) {
                        this.textError = 'El archivo no cumple con el tamaño, carga el archivo nuevamente.'
                    }
                }
            } else if (this.categoryName == 'Manuales') {
                if (fileType == 'application/pdf' && fileSize <= this.maxFileSize) {
                    this.selectedFile = file
                    this.inputErrorValidate = false
                    this.textError = ''
                }
                else {
                    this.inputErrorValidate = true
                    this.$refs.fileInput.reset()
                    if (fileType != 'application/pdf') {
                        this.textError = 'El archivo no cumple con el formato, carga el archivo nuevamente.'
                        return
                    }
                    if (fileSize > this.maxFileSize) {
                        this.textError = 'El archivo no cumple con el tamaño, carga el archivo nuevamente.'
                    }
                }
            } else {
                if ((fileType == 'image/png' || fileType == 'image/jpg' || fileType == 'image/jpeg') && fileSize <= this.maxFileSize) {
                    this.selectedFile = file
                    this.inputErrorValidate = false
                    this.textError = ''
                } else {
                    this.inputErrorValidate = true
                    this.$refs.fileInput.reset()
                    if (fileType != 'image/png' || fileType != 'image/jpg' || fileType != 'image/jpeg') {
                        this.textError = 'El archivo no cumple con el formato, carga el archivo nuevamente.'
                    }
                    if (fileSize > this.maxFileSize) {
                        this.textError = 'El archivo no cumple con el tamaño, carga el archivo nuevamente.'
                    }
                }
            }
        },
        async insUpdateFile() {


            //validación de formulario 


            this.isLoading = true
            //Detectar que endpoint es 
            const endpointUpdate = this.categoryName == 'Videos' ? 'ActualizarVideo' : this.categoryName == 'Manuales' ? 'ActualizarManual' : 'ActualizarPost';
            const endpointInsert = this.categoryName == 'Videos' ? 'GuardarVideo' : this.categoryName == 'Manuales' ? 'GuardarManual' : 'GuardarPost';
            //Construcción de formdata 
            const body = new FormData();
            //Body para Manuales

            //Construcción de backGround overlay para videos 
            let response = null
            if (!this.isEditionResource) response = await axios.get('/img/images/background.png', { responseType: 'blob' });

            if (this.categoryName === 'Videos') {
                if (this.isEditionResource) body.append("videoId", this.id);

                body.append("video", this.selectedFile);
                body.append("titulo", this.title);
                if (!this.isEditionResource) body.append("imagen", new Blob([response.data], { type: 'image/png' }), 'background.png');
                body.append("descripcion", 'Sin descripción');
            }
            else if (this.categoryName === 'Manuales') {
                if (this.isEditionResource) body.append("manualId", this.id);
                body.append("manual", this.selectedFile);
                body.append("titulo", this.title);
                body.append("descripcion", this.description);
            }
            else {
                if (this.isEditionResource) body.append("postId", this.id);
                body.append("imagen", this.selectedFile);
                body.append("titulo", this.title);
                body.append("descripcion", this.description);
                body.append("redireccion", this.link);
            }
            try {
                if (this.isEditionResource) await axios.post(ruteBibliotecaDigital + endpointUpdate, body)
                else await axios.post(ruteBibliotecaDigital + endpointInsert, body)
                URL.revokeObjectURL(this.linkManual);
                URL.revokeObjectURL(this.src_img);
                URL.revokeObjectURL(this.src_video);
                this.selectedFile = null
                this.cargaExitosa = true;
                this.$router.push({name:'AdministracionBibliotecaDigital'})
            } catch (error) {
                this.cargaErronea = true;
            } finally {
                this.isLoading = false
                setTimeout(() => {
                    this.cargaExitosa = false;
                    if (this.cargaErronea) this.cargaErronea = false
                }, 5000);
            }

        },
        setNewCurrentResource() {
            this.id = this.currentDocument.id
            this.title = this.currentDocument.titulo || ''
            this.description = this.currentDocument.texto || ''
            this.src_img = this.currentDocument.imgCover ? this.currentDocument.imgCover + '?nocache=' + Date.now() : ''
            this.src_video = this.currentDocument.enlaceVideo ? this.currentDocument.enlaceVideo + '?nocache=' + Date.now() : ''
            this.type = this.currentDocument.tipo || ''
            this.size = this.currentDocument.size || ''
            this.dateCreated = this.currentDocument.fechaModificacion || ''
            this.link = this.currentDocument.enlace || ''
            this.linkManual = this.currentDocument.linkManual ? this.currentDocument.linkManual + '?nocache=' + Date.now() : ''
        },
        setPreviewResource() {
            // Crear una URL local para la vista previa de la imagen
            if (this.categoryName == 'Videos') {

                const input = this.selectedFile
                const videoElement = this.$refs.videoElement;

                if (input) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        videoElement.src = e.target.result;
                        this.videoSrc = e.target.result;
                    };
                    reader.readAsDataURL(input);
                } else {
                    videoElement.src = "";
                    this.videoSrc = null;
                }
            }
            else if (this.categoryName == 'Manuales') {
                this.linkManual = URL.createObjectURL(this.selectedFile);
            }
            else {
                this.src_img = URL.createObjectURL(this.selectedFile);
            }
            this.dialog = false

        },
        dragOver(event) {
            event.preventDefault();
            // Agregar estilos CSS de resaltado cuando se arrastra un archivo
            event.target.classList.add("drag-over");
        },
        dragLeave(event) {
            event.target.classList.remove("drag-over");
        },
        dropFile(event) {
            event.preventDefault();
            event.target.classList.remove("drag-over");
            const file = event.dataTransfer.files[0];
            this.validateFile(file)
        },
    },
    async mounted() {
        this.setNewCurrentResource()
        URL.revokeObjectURL(this.linkManual);
        URL.revokeObjectURL(this.src_img);
        URL.revokeObjectURL(this.src_video);

    },
    computed: {
        categoryName() {
            return this.$store.state.categoryName
        },
        currentDocument() {
            return this.$store.state.currentDocument;
        },
        acceptedFileTypes() {
            if (this.categoryName == 'Videos') {
                return '.mp4, .avi'
            } else if (this.categoryName == 'Manuales') {
                return '.pdf'
            } else {
                return '.jpg, .jpeg, .png'
            }
        },
        maxFileSize() {
            if (this.categoryName == 'Videos') {
                return 104857600
            } else if (this.categoryName == 'Manuales') {
                return 20971520
            } else {
                return 2097152
            }
        },
        isEditionResource() {
            return this.$store.state.isEditionResource
        }
    }


}
</script>

<style lang="scss" scoped>
#input_file_biblioteca>*.v-input__slot {
    padding: 0 !important;
}

.custom-file-input * fieldset {
    background-color: red !important;
    border: 1px solid #ff0000;
    /* Cambiar el color del borde según tus preferencias */
}

.v-input__control {
    height: 100px !important;
}

.drop-area {
    text-align: center;
    cursor: pointer;
    transition: 0.3s all;
}

.drop-area.drag-over {
    transition: 0.3s all;
}
</style>